import styled from 'styled-components';

export const OpGeneralEditorDiv = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;
